import { jsx as _jsx } from "react/jsx-runtime";
import { INITIAL_STATE, sideContentReducer, Context, } from '#pplx/frontend/apps/ask/search-side-content/core/ProviderShared.js';
import { useNavigationGuards } from '#pplx/frontend/router/navigationGuard.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import React, { useCallback, useEffect, useMemo, useReducer, useRef } from 'react';
export const SideContentProvider = ({ children }) => {
    const [state, rawDispatch] = useReducer(sideContentReducer, INITIAL_STATE);
    const { requestNavigation } = useNavigationGuards();
    const pathname = usePathname();
    const prevPathnameRef = useRef(pathname);
    useEffect(() => {
        if (prevPathnameRef.current !== pathname) {
            prevPathnameRef.current = pathname;
            rawDispatch({ action: 'close' });
        }
    }, [pathname]);
    const dispatch = useCallback((action) => {
        const applyAction = () => rawDispatch(action);
        if (state.tab?.name === 'canvas' &&
            (action.action === 'close' || (action.action === 'open' && action.tabType !== 'canvas'))) {
            requestNavigation(applyAction);
        }
        else
            applyAction();
    }, [state.tab?.name, requestNavigation]);
    const value = useMemo(() => ({
        ...state,
        dispatch,
    }), [state, dispatch]);
    return _jsx(Context.Provider, { value: value, children: children });
};
//# sourceMappingURL=Provider.js.map